import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ModuleSelection } from '@app/dialogs';

@Component({
    selector: 'app-course-module-list',
    templateUrl: './module-list.component.html',
    styleUrls: ['./module-list.component.css'],
    imports: [TranslateModule, ButtonModule, CdkDropList, CdkDrag],
})
export class ModuleListComponent {
    readonly modules = input.required<ModuleSelection[]>();
    readonly testId = input.required<string>();

    readonly add = output<void>();
    readonly remove = output<string>();
    readonly reorder = output<ModuleSelection[]>();

    moveModule(index: number, direction: -1 | 1): void {
        const modules = [...this.modules()];
        moveItemInArray(modules, index, index + direction);
        this.reorder.emit(modules);
    }

    onDrop(event: CdkDragDrop<ModuleSelection[]>): void {
        const modules = [...this.modules()];
        moveItemInArray(modules, event.previousIndex, event.currentIndex);
        this.reorder.emit(modules);
    }
}
